/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BinsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a bin
     * @returns any Bin created
     * @throws ApiError
     */
    public createBin({
        requestBody,
    }: {
        requestBody?: {
            warehouse_id: string;
            name: string;
        },
    }): CancelablePromise<{
        id: string;
        warehouse_id: string;
        name: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/bins',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                403: `Owner role required`,
                404: `Warehouse not found`,
                409: `Bin already exists`,
            },
        });
    }
    /**
     * Rename a bin
     * @returns any Bin updated
     * @throws ApiError
     */
    public updateBin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            name: string;
        },
    }): CancelablePromise<{
        id: string;
        warehouse_id: string;
        name: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/bins/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                403: `Owner role required`,
                404: `Bin not found`,
                409: `Bin name already exists`,
            },
        });
    }
    /**
     * Get a bin
     * @returns any Bin details
     * @throws ApiError
     */
    public getBin({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        id: string;
        warehouse_id: string;
        name: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/bins/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                404: `Bin not found`,
            },
        });
    }
    /**
     * List bins for a warehouse
     * @returns any Bins for the warehouse
     * @throws ApiError
     */
    public getBinsByWarehouse({
        warehouseId,
    }: {
        warehouseId: string,
    }): CancelablePromise<Array<{
        id: string;
        warehouse_id: string;
        name: string;
        created_at: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/warehouses/{warehouse_id}/bins',
            path: {
                'warehouse_id': warehouseId,
            },
            errors: {
                401: `Authentication required`,
                404: `Warehouse not found`,
            },
        });
    }
}
